'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _loadingCells = require('./loadingCells');

var _loadingCells2 = _interopRequireDefault(_loadingCells);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Loading(_ref) {
  var columns = _ref.columns;
  var columnsLength = columns.length;
  return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('tr', null, _react2.default.createElement(_loadingCells2.default, {
    columns: columns,
    value: columnsLength
  })), _react2.default.createElement('tr', null, _react2.default.createElement(_loadingCells2.default, {
    columns: columns,
    value: columnsLength
  })), _react2.default.createElement('tr', null, _react2.default.createElement(_loadingCells2.default, {
    columns: columns,
    value: columnsLength - 1
  })), _react2.default.createElement('tr', null, _react2.default.createElement(_loadingCells2.default, {
    columns: columns,
    value: columnsLength - 3
  })));
}

Loading.propTypes = {
  columns: _propTypes2.default.array
};
Loading.defaultProps = {
  columns: []
};